/*
 * Public API Surface of angular-calendar-year-view
 */

export * from './lib/angular-calendar-year-view.component';
export * from './lib/angular-calendar-year-view.module';
